module.exports = __webpack_public_path__ + "static/img/2-10-普通退货退款建单.e67f907.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-10-普通退货退款建单.png
// module id = 1345
// module chunks = 0